import { api, ApiError } from '../api';
import { el, errorBanner, skeletonTable , appendAll} from '../components/layout';
import { dataTable } from '../components/table';

type Client = {
  id: number;
  name: string;
  website_url: string;
  market: string;
  is_active: number;
  notes: string | null;
  created_at: string;
};

export function renderClientsPage(root: HTMLElement) {
  const content = el('div');
  appendAll(content, el('div', { className: 'page-header' }, [
      el('h1', { text: 'Clients' }),
      el('button', {
        className: 'btn btn-primary',
        type: 'button',
        text: 'New Client',
        onClick: () => {
          showForm = !showForm;
          paint();
        },
      }),
    ]),
  );

  const host = el('div');
  host.appendChild(skeletonTable());
  content.appendChild(host);
  root.appendChild(content);

  let items: Client[] = [];
  let showForm = false;
  let formName = '';
  let formUrl = '';
  let formMarket = 'socal';
  let formNotes = '';

  async function load() {
    try {
      const data = await api<{ items: Client[] }>('/api/clients?all=1');
      items = data.items || [];
      paint();
    } catch (err) {
      const msg = err instanceof ApiError ? err.message : String(err);
      host.replaceChildren(errorBanner(msg, load));
    }
  }

  function paint() {
    const wrap = el('div');

    if (showForm) {
      const form = el('div', { className: 'card' });
      const nameIn = el('input', {
        className: 'input',
        value: formName,
        placeholder: 'Name',
      }) as HTMLInputElement;
      nameIn.addEventListener('input', () => {
        formName = nameIn.value;
      });
      const urlIn = el('input', {
        className: 'input',
        value: formUrl,
        placeholder: 'https://example.com',
      }) as HTMLInputElement;
      urlIn.addEventListener('input', () => {
        formUrl = urlIn.value;
      });
      const marketIn = el('input', {
        className: 'input',
        value: formMarket,
        placeholder: 'market',
      }) as HTMLInputElement;
      marketIn.addEventListener('input', () => {
        formMarket = marketIn.value;
      });
      const notesIn = el('input', {
        className: 'input',
        value: formNotes,
        placeholder: 'Notes',
      }) as HTMLInputElement;
      notesIn.addEventListener('input', () => {
        formNotes = notesIn.value;
      });

      appendAll(form, el('div', { className: 'step-title', text: 'New client' }),
        el('div', { className: 'field' }, [nameIn]),
        el('div', { className: 'field' }, [urlIn]),
        el('div', { className: 'field' }, [marketIn]),
        el('div', { className: 'field' }, [notesIn]),
        el('div', { className: 'row-actions' }, [
          el('button', {
            className: 'btn btn-primary',
            type: 'button',
            text: 'Save',
            onClick: async () => {
              try {
                await api('/api/clients', {
                  method: 'POST',
                  body: JSON.stringify({
                    name: formName.trim(),
                    website_url: formUrl.trim(),
                    market: formMarket.trim() || 'socal',
                    notes: formNotes.trim() || null,
                  }),
                });
                showForm = false;
                formName = '';
                formUrl = '';
                formMarket = 'socal';
                formNotes = '';
                await load();
              } catch (err) {
                alert(err instanceof Error ? err.message : String(err));
              }
            },
          }),
          el('button', {
            className: 'btn',
            type: 'button',
            text: 'Cancel',
            onClick: () => {
              showForm = false;
              paint();
            },
          }),
        ]),
      );
      wrap.appendChild(form);
    }

    appendAll(wrap, dataTable<Client>({
        columns: [
          { key: 'name', label: 'Name', render: (c) => c.name },
          {
            key: 'website',
            label: 'Website',
            render: (c) =>
              el('a', {
                href: c.website_url,
                target: '_blank',
                rel: 'noopener',
                text: c.website_url,
              }),
          },
          { key: 'market', label: 'Market', render: (c) => c.market || '-' },
          {
            key: 'active',
            label: 'Active',
            render: (c) => {
              const cb = el('input', { type: 'checkbox' }) as HTMLInputElement;
              cb.checked = Number(c.is_active) === 1;
              cb.addEventListener('change', async () => {
                try {
                  await api(`/api/clients/${c.id}`, {
                    method: 'PATCH',
                    body: JSON.stringify({ is_active: cb.checked }),
                  });
                  c.is_active = cb.checked ? 1 : 0;
                } catch (err) {
                  cb.checked = !cb.checked;
                  alert(err instanceof Error ? err.message : String(err));
                }
              });
              return cb;
            },
          },
          { key: 'notes', label: 'Notes', render: (c) => c.notes || '-' },
          {
            key: 'created',
            label: 'Created',
            render: (c) => String(c.created_at || '').replace('T', ' ').slice(0, 19),
          },
        ],
        rows: items,
      }),
    );

    host.replaceChildren(wrap);
  }

  load();
}
